import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';

class Contact extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      deleting : false
    }
  }
  render() {
    const { contact } = this.props;
    const { deleting } = this.state;

    return (
    <div>
      {!deleting ? (
        <div>
          <figure className="image rounded">
            <i className="fa fa-user fa-2x"></i>
          </figure>
          <span className="title">{contact.name}
            <span onClick={e => this.setState({ deleting : true })} className="btn btn-default pull-right"><i className="fa fa-trash"></i></span>
            <span className="pull-right mr-sm"><i className="fa fa-phone"></i> {contact.phone || 'No phone provided.'}</span>
          </span>
          <span className="message truncate">{contact.notes}</span>
        </div>
      ) : (
        <div className="row well">
          <div className="col-xs-12">Are you sure you want to delete {contact.name}?</div>
          <div className="col-xs-12 col-md-6">
            <div onClick={e => this.setState({deleting: false})} className="btn btn-block btn-default">Cancel</div>
          </div>
          <div className="col-xs-12 col-md-6">
            <div onClick={e => {
              this.props.deleteContact(contact);
              this.setState({deleting : false});
            }} className="btn btn-block btn-danger"><i className="fa fa-trash"></i> Yes, Delete Contact.</div>
          </div>
        </div>
      )}
    </div>
    );
  }
}

Contact.propTypes = {
  contact : PropTypes.object,
}
const mapStateToProps = ({ contacts }) => ({ ...contacts});

export default connect(mapStateToProps, Actions)(Contact);



// WEBPACK FOOTER //
// ./src/browser/components/client/contacts/contact.js